import { PRECISION } from "lib/numbers";
import { bigMath } from "sdk/utils/bigmath";

export function getBreakevenPriceMove({
  markPrice,
  entryPrice,
  isLong,
}: {
  markPrice: bigint | undefined;
  entryPrice: bigint | undefined;
  isLong: boolean;
}) {
  if (markPrice === undefined || entryPrice === undefined || markPrice <= 0n || entryPrice <= 0n) {
    return undefined;
  }

  const move = isLong ? entryPrice - markPrice : markPrice - entryPrice;

  return move > 0n ? move : 0n;
}

export function getBreakevenPriceMovePercentage({
  markPrice,
  breakevenMove,
}: {
  markPrice: bigint | undefined;
  breakevenMove: bigint | undefined;
}) {
  if (markPrice === undefined || breakevenMove === undefined || markPrice <= 0n) {
    return undefined;
  }

  return bigMath.mulDiv(breakevenMove, PRECISION, markPrice);
}
